module.exports = __webpack_public_path__ + "static/Rosewater1-21cd0be53430de422847267e3c9dc8fe.webp";